import { useBoundStore } from "useStore";
import FilterChip from "./FilterChip";
import { Stack } from "@mui/material";

export default function CategoryPathFilterChip() {
  const selectedCategory = useBoundStore(
    (state) => state.campaignManagerSelectedCategoryPath,
  );
  const toggleSelectedCategory = useBoundStore(
    (state) => state.toggleCampaignManagerSelectedCategoryPath,
  );

  if (!selectedCategory || selectedCategory.length === 0) return null;

  return (
    <Stack direction="row" flexWrap="wrap" gap={1}>
      {selectedCategory.map((category) => (
        <FilterChip
          key={category}
          filterName="Categoría"
          title={category}
          onDelete={() => toggleSelectedCategory(category)}
        />
      ))}
    </Stack>
  );
}
